import { IntlTFunc } from 'next-intl';

import { ProductFragment } from '@/fo/api/magento';

import { MappedProduct, ConfigurableProduct, ProductsMindbox } from '../types';
import { configurableVariantsMapper } from '../utils';

import { utilMapSimpleProductData } from './utilMapSimpleProductData';

export const utilMapConfigurableProductData = (
  product: ProductFragment,
  t: IntlTFunc,
  mindboxProducts?: ProductsMindbox,
  options?: { preselectFirstInStock?: boolean; selectedSku?: string }
): MappedProduct => {
  const productData = product as ConfigurableProduct;

  const {
    sku,
    mindboxId,
    link,
    basePrice,
    finalPrice,
    labels,
    baseImage,
    thumbnail,
    structureImage,
    mediaGallery,
    stockStatus,
    characteristics,
    brand,
    catalogBrandUrl,
    series,
    effects,
    benefits,
    volume,
    labelsBonus,
    bonusPoints,
    bonusPointsMax,
    earnedBonusPoints,
    video,
    banners,

    name,
    subtitle,
    shortDescription,
    firstLevelCategory,
    lastLevelCategory,
    breadcrumbs,
    labelsBrand,
    rating,
    reviewCount,
    bestRating,
    worstRating,

    description_html,
    activeComponents,
    composition,
    usageInstructions,
    expert,

    productGroup,
    diagnosticLabels,
    videoExpertOpinionPreview,
    videoExpertOpinionVideo,
    videoExpertOpinionExpertUrlKey,
    certificateUrl
  } = utilMapSimpleProductData(productData, t, mindboxProducts);

  // const configurable = getFragmentData(
  //   ConfigurableProductFragmentDoc,
  //   product // TODO: здесь ошибка типизации пришлось нижу указать через as
  // );

  const configurableVariants =
    'variants' in productData && productData.variants
      ? configurableVariantsMapper(
          productData.variants,
          t,
          mindboxProducts,
          options
        )
      : [];

  const selectedProduct: MappedProduct | undefined = configurableVariants.find(
    (variant) => variant.isSelected
  )?.product;

  return {
    parentSku: sku,
    sku: selectedProduct?.sku ?? sku,
    mindboxId: selectedProduct?.mindboxId ?? mindboxId,
    link,
    name,
    brand,
    brandCode: selectedProduct?.brandCode ?? '',
    catalogBrandUrl,
    series,
    subtitle,
    shortDescription,
    basePrice: selectedProduct?.basePrice ?? basePrice,
    finalPrice: selectedProduct?.finalPrice ?? finalPrice,
    firstLevelCategory,
    lastLevelCategory,
    breadcrumbs,
    labelsBrand,
    labels: selectedProduct?.labels ?? labels,
    labelsBonus: selectedProduct?.labelsBonus ?? labelsBonus,
    baseImage: selectedProduct?.baseImage ?? baseImage,
    thumbnail: selectedProduct?.thumbnail ?? thumbnail,
    structureImage: selectedProduct?.structureImage ?? structureImage,
    mediaGallery: selectedProduct?.mediaGallery ?? mediaGallery,
    rating,
    reviewCount,
    bestRating,
    worstRating,
    stockStatus: selectedProduct?.stockStatus ?? stockStatus,
    stockQuantity: selectedProduct?.stockQuantity ?? 0,
    configurableVariants,
    effects,
    benefits: selectedProduct?.benefits ?? benefits,
    volume: selectedProduct?.volume ?? volume,
    bonusPoints: selectedProduct?.bonusPoints ?? bonusPoints,
    bonusPointsMax: selectedProduct?.bonusPointsMax ?? bonusPointsMax,
    earnedBonusPoints: selectedProduct?.earnedBonusPoints ?? earnedBonusPoints,
    video: selectedProduct?.video ?? video,
    parentVideo: video,
    banners,

    description_html,
    characteristics: selectedProduct?.characteristics ?? characteristics,
    activeComponents,
    composition,
    usageInstructions,
    expert,

    productGroup,
    diagnosticLabels: selectedProduct?.diagnosticLabels ?? diagnosticLabels,
    videoExpertOpinionPreview,
    videoExpertOpinionVideo,
    videoExpertOpinionExpertUrlKey,
    certificateUrl: selectedProduct?.certificateUrl ?? certificateUrl
  };
};
